/**
 * Sum values for specific key in the object
 * @param values array of object
 * @param key key
 * @param check custom check function to to indicate if certain object included or not in the summation
 * @returns number
 */
export function getSum(values, key, check = null) {
    let sum = 0;
    for (const current of values) {
        if (check?.(current)) {
            const value = current[key];
            if (!value || typeof value !== 'number')
                continue;
            sum += Math.abs(value);
        }
    }
    return sum;
}
//# sourceMappingURL=getSum.js.map